import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { Subject, BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  public config: Subject<any>;
  public landing: Subject<any>;
  public programs: Subject<any>;
  public cantTypes: Subject<any>;
  public programSena: Subject<any>;
  public datalayer: Subject<any>;

  header:HttpHeaders = new HttpHeaders({
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    'Accept': 'application/json, text/javascript, */*; q=0.01'
  })
  constructor(private http: HttpClient) {
    this.config = new BehaviorSubject<any>(undefined);      
    this.programs = new BehaviorSubject<any>(undefined);   
    this.programSena = new BehaviorSubject<any>(undefined);   
    this.landing = new BehaviorSubject<any>(undefined);  
    this.datalayer = new BehaviorSubject<any>(undefined);
  }

  getConfig(){
    return this.http.get("https://andina.hechoparaliderar.com/SIAF/apps/landings/universidades/FUAA/landings/assets/config/config.php", {headers:this.header})
    //return this.http.get("assets/config/config.json", {headers:this.header});
  }

  getConfigData(){
    return this.http.post(`${this.config["sever"]}${this.config["services"].cms}`, 
    this.getEncodedString({service: 1, forms: JSON.stringify([{name:"config", value:"1053"},{name:"configForm", value:"1138"}])}),
    {headers:this.header});
  }

  getConfigDatalayer(){
    var pepe = this.http.post(`${this.config["sever"]}${this.config["services"].cms}`, 
    this.getEncodedString({service: 1, forms: JSON.stringify([{ "name": "tipoProg", "value": "1033" },{"name":"programasNC","value":"1034"},
    {"name":"modalidad","value":"1036"},{"name":"oportunidad","value":"1035"}])}),
    {headers:this.header});
    return pepe
  }

  private getEncodedString(params:any){
    let str = '';
    for (let name in params) {
        str += name + '=' + encodeURIComponent(params[name]) + '&'
    }
    let pos = str.length;
    str = str.substring(0, pos - 1) + str.substring(pos, str.length);
    return str;
  }

}
